// extracted by mini-css-extract-plugin
export default {"actionButton":"VerifyModal_actionButton__3LoEw"};